import React, { useEffect } from "react";
import { connect } from "react-redux";
import { withStyles } from "@material-ui/styles";
import Grid from "@material-ui/core/Grid";
import TextField from "../../../../../../ui/TextField";
import DataSelect from "../../../../../../ui/DataSelect";
import {getPrograms, getOrganizations} from "../../../../../../Study/Plan/store/actions";

const initialData = {
  name: "",
  capacity: 0,
  duration: 0,
  date: "",
  timeStart: "",
  organization: null,
  program: null
};

const styles = () => ({
  root: {
    "& .MuiFormLabel-root": {
      whiteSpace: "nowrap"
    }
  },
});

const AddMasterClassForm = ({ disabled,
                              onFormChange,
                              classes,
                              getOrganizations,
                              organizations,
                              getPrograms,
                              programs}) => {
  const [data, setData] = React.useState(initialData);
  const { name, capacity, duration, date, timeStart, organization, program } = data;

  useEffect(() => {
    getOrganizations();
  }, []);

  React.useEffect(() => {
    if (organization && organization > -1) {
      getPrograms(organization);
    }
  }, [organization]);

  const onChange = (field, value) => {
    const newState = {
      ...data,
      [field]: value
    };

    setData(newState);
    onFormChange(newState);
  };

  return (
    <div className={classes.root}>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <TextField
            required
            value={name || ""}
            onChange={e => onChange("name", e.target.value)}
            label="Наименование"
            disabled={disabled}
          />
        </Grid>
        <Grid item xs={6}>
          <TextField
            required
            value={date}
            onChange={e => onChange("date", e.target.value)}
            label="Дата"
            format="dd.MM.yyyy"
            type="date"
            disabled={disabled}
          />
        </Grid>
        <Grid item xs={6}>
          <TextField
            required
            value={timeStart || ""}
            onChange={e => onChange("timeStart", e.target.value)}
            label="Начало занятий"
            disabled={disabled}
            type="time"
            inputProps={{
              step: 300, // 5 min
            }}
          />
        </Grid>
        <Grid item xs={6}>
          <TextField
            value={capacity || ""}
            onChange={e => onChange("capacity", e.target.value)}
            label="Макс. кол-во"
            disabled={disabled}
          />
        </Grid>
        <Grid item xs={6}>
          <TextField
            required
            value={duration || ""}
            onChange={e => onChange("duration", e.target.value)}
            label="Продолжительность, ч."
            disabled={disabled}
          />
        </Grid>
        <Grid item xs={12}>
          {organizations && <DataSelect
            value={organization}
            onChange={value => onChange("organization", value.id)}
            label="Подрядчик"
            dataSource={organizations}
            disabled={disabled}
            required/>}
        </Grid>
        <Grid item xs={12}>
          {programs && <DataSelect
            keyField="_key"
            value={program}
            onChange={value => onChange("program", value._key)}
            label="Программа/Модуль"
            dataSource={programs}
            disabled={disabled}
            required/>}
        </Grid>
      </Grid>
    </div>
  );
};

const mapStateToProps = state => ({
  isFetchingOrganizations: state.studyPlan.isFetchingOrganizations,
  organizations: state.studyPlan.organizations,
  isFetchingPrograms: state.studyPlan.isFetchingPrograms,
  programs: state.studyPlan.programs
});

const mapDispatchToProps = dispatch => ({
  getOrganizations: () => dispatch(getOrganizations()),
  getPrograms: (orgId) => dispatch(getPrograms(orgId))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(AddMasterClassForm));
